"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmperorsWeaknessAbilityHandler = exports.EmperorsWeaknessActorAbilityFactory = exports.EmperorsWeaknessAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class EmperorsWeaknessAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EmperorsWeakness;
        this.__typeName = "EmperorsWeakness";
    }
}
exports.EmperorsWeaknessAbilityArgs = EmperorsWeaknessAbilityArgs;
let EmperorsWeaknessActorAbilityFactory = class EmperorsWeaknessActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EmperorsWeakness", "OneEnemies", 0);
    }
};
EmperorsWeaknessActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EmperorsWeakness")
], EmperorsWeaknessActorAbilityFactory);
exports.EmperorsWeaknessActorAbilityFactory = EmperorsWeaknessActorAbilityFactory;
let EmperorsWeaknessAbilityHandler = class EmperorsWeaknessAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const level = container.getLevel(ability.invokerId);
        const attributeDecrease = 1;
        container.applyMultiAttack({
            sequence,
            attackType: "ranged",
            abilityKey: "EmperorsWeakness",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Death", 80)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Permanent,
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Power, attributeDecrease),
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Focus, attributeDecrease),
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Toughness, attributeDecrease),
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Vitality, attributeDecrease),
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Will, attributeDecrease),
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Luck, attributeDecrease),
                        ], true),
                    }
                ],
            })),
        });
    }
};
EmperorsWeaknessAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EmperorsWeakness)
], EmperorsWeaknessAbilityHandler);
exports.EmperorsWeaknessAbilityHandler = EmperorsWeaknessAbilityHandler;
